import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Empty } from 'antd';
import { ChatCircle, User } from '@phosphor-icons/react';
import Typography from '../../components/Typography';
import ReferralMessages from './ReferralMessages';
import './messagesPage.scss';

const MessagesPage = ({ referrals, cable, user, loggedIn, onMarkRead }) => {
  const [selectedSlug, setSelectedSlug] = useState(null);

  const handleSelectConversation = (slug) => {
    setSelectedSlug(slug);
    if (onMarkRead) onMarkRead(slug);
  };

  const selectedReferral = referrals.find((r) => r.slug === selectedSlug);

  return (
    <div className="messages-page">
      <div className="messages-page__header">
        <Typography variant="h1" size="large" bold>
          Messages
        </Typography>
        <Typography variant="text" size="small" className="messages-page__subtitle">
          View conversations across your referrals
        </Typography>
      </div>

      <div className="messages-page__body">
        {/* Conversation list */}
        <div className="messages-page__sidebar">
          <div className="messages-page__sidebar-header">
            <span className="messages-page__sidebar-title">
              Conversations
              <span className="messages-page__sidebar-count">
                {referrals.length}
              </span>
            </span>
          </div>
          <div className="messages-page__sidebar-list">
            {referrals.length === 0 ? (
              <div className="messages-page__empty-sidebar">
                <Empty description="No referrals" image={Empty.PRESENTED_IMAGE_SIMPLE} />
              </div>
            ) : (
              referrals.map((referral) => (
                <button
                  key={referral.id}
                  type="button"
                  className={`messages-page__conversation ${selectedSlug === referral.slug ? 'messages-page__conversation--active' : ''}`}
                  onClick={() => handleSelectConversation(referral.slug)}
                >
                  <div className="messages-page__conversation-avatar">
                    <User size={18} weight="bold" />
                  </div>
                  <div className="messages-page__conversation-info">
                    <span className="messages-page__conversation-name">
                      {referral.patient_name || 'Unknown Patient'}
                    </span>
                    <span className="messages-page__conversation-provider">
                      {referral.referring_organization || referral.referring_provider || ''}
                    </span>
                  </div>
                  {referral.unread_messages_count > 0 && (
                    <span className="messages-page__unread-badge">
                      {referral.unread_messages_count}
                    </span>
                  )}
                </button>
              ))
            )}
          </div>
        </div>

        {/* Chat panel */}
        <div className="messages-page__chat">
          {selectedSlug ? (
            <ReferralMessages
              key={selectedSlug}
              slug={selectedSlug}
              archived={selectedReferral?.archived}
              cable={cable}
              user={user}
              loggedIn={loggedIn}
            />
          ) : (
            <div className="messages-page__empty-chat">
              <div className="messages-page__empty-chat-icon">
                <ChatCircle size={32} weight="light" />
              </div>
              <Typography variant="text" className="messages-page__empty-text">
                Select a conversation
              </Typography>
              <Typography variant="text" size="xsmall" className="messages-page__empty-hint">
                Choose a referral from the left to start messaging
              </Typography>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

MessagesPage.propTypes = {
  referrals: PropTypes.array,
  cable: PropTypes.object,
  user: PropTypes.object,
  loggedIn: PropTypes.bool,
  onMarkRead: PropTypes.func,
};

MessagesPage.defaultProps = {
  referrals: [],
  cable: null,
  user: null,
  loggedIn: false,
  onMarkRead: null,
};

export default connect((state) => ({
  user: state.auth.data,
  loggedIn: !!state.auth.hasAuthCreds,
}))(MessagesPage);
